// Mac masaüstü uygulaması (elitlig-mac) algılama.
//
// Masaüstü uygulaması siteyi kendi penceresinde açar ve User-Agent'ına
// "ElitligDesktop/<sürüm>" imini ekler; ön yükleme betiği ayrıca
// window.elitligDesktop nesnesini tanımlar. Bu modda yönetim kabuğu yalnız
// iş akışı ve Araçlarım bölümlerini gösterir; giriş sonrası Araçlar Merkezi açılır. Sunucu da
// aynı imi görüp 90 günlük masaüstü oturumu verir (routes/User.js).
export const DESKTOP_USER_AGENT_MARK = /\bElitligDesktop\//;

export const isDesktopApp = (nav = typeof navigator !== "undefined" ? navigator : null, win = typeof window !== "undefined" ? window : null) =>
  Boolean(win?.elitligDesktop) || DESKTOP_USER_AGENT_MARK.test(String(nav?.userAgent || ""));

// Masaüstü uygulamasında yönetim menüsünde kalan gruplar.
export const DESKTOP_NAV_GROUP_KEYS = ["is-akisi", "araclar"];
